import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, className = "" }) {
  const container = {
    hidden: {},
    show: { transition: { staggerChildren: 0.12, delayChildren: 0.15 } },
  };
  const line = {
    hidden: { y: "110%" },
    show: { y: "0%", transition: { duration: 0.85, ease: [0.76, 0, 0.24, 1] } },
  };
  return (
    <motion.div variants={container} initial="hidden" animate="show" className={className}>
      {lines.map((l, i) => (
        <div key={i} style={{ overflow: "hidden", display: "block" }}>
          <motion.span variants={line} style={{ display: "block" }}>
            {l}
          </motion.span>
        </div>
      ))}
    </motion.div>
  );
}
